import { useMemo } from 'react';
import { prop } from 'ramda';

import { useIsAdmin } from '@core/js/hooks/user';
import { htcmdService } from '@core/js/services/htcmd.service';
import { storageService } from '@core/js/services/storage.service';
import { useDeviceSelector } from '@core/js/store/hooks';

import { useDynamicTags } from '@interlayer/js/app/hooks/useDynamicTags';
import { DYNAMIC_TAG_NAMES } from '@interlayer/js/app/utils/constants';

import { DOWNLOAD_APP_LINK, STATE_DOWNLOAD_APP_PROMPT } from '../constants';

export const useDownloadApp = (withoutStorage?: boolean): boolean => {
    const isAdmin = useIsAdmin();
    const os = useDeviceSelector(prop('os'));
    const [isDownloadAppPrompt] = useDynamicTags([DYNAMIC_TAG_NAMES.isDownloadAppPrompt]);

    return useMemo(() =>
        (os === 'android' || os === 'ios')
        && Boolean(isDownloadAppPrompt) && isDownloadAppPrompt !== 'false'
        && !isAdmin
        && !htcmdService.isEnabled
        && !window.callPhantom
        && (withoutStorage || storageService.local.getItem(DOWNLOAD_APP_LINK) === STATE_DOWNLOAD_APP_PROMPT.NEED_TO_SHOW),
    [os, isDownloadAppPrompt, isAdmin, withoutStorage]
    );
};
